import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEOMetadata from '../components/SEOMetadata';

const content = {
  privacy: {
    label: 'Правовая информация',
    title: 'Политика конфиденциальности',
    description: 'Как LNG AUA обрабатывает данные при использовании сайта и Telegram-бота.',
    sections: [
      ['Какие данные обрабатываются', 'Сайт может получать технические сведения о визите: адрес страницы, источник перехода, параметры устройства, язык браузера и обезличенный идентификатор сессии. При работе с Telegram-ботом обрабатываются идентификатор Telegram, сообщения и файлы, необходимые для выполнения перевода, а также сведения об оплатах и балансе.'],
      ['Зачем нужны данные', 'Данные используются для предоставления перевода, учёта доступного лимита, поддержки пользователя, защиты сервиса от злоупотреблений и улучшения работы продукта.'],
      ['Передача сервисам', 'Для выполнения отдельных операций данные могут передаваться поставщикам инфраструктуры, AI-моделей и платежей только в объёме, необходимом для работы соответствующей функции.'],
      ['Хранение и защита', 'Мы применяем разграничение доступа и технические меры защиты. Не отправляйте в перевод секреты, пароли, платёжные реквизиты и иную информацию, раскрытие которой может причинить вред.'],
      ['Ваши обращения', 'По вопросам удаления или уточнения данных обратитесь через раздел поддержки или официальный Telegram-бот. Запрос может потребовать подтверждения принадлежности аккаунта.']
    ]
  },
  terms: {
    label: 'Правовая информация',
    title: 'Условия использования',
    description: 'Основные правила работы с сайтом LNG AUA и ботом @lngaua_bot.',
    sections: [
      ['Назначение сервиса', 'LNG AUA предоставляет автоматизированный перевод текста и голоса. AI-перевод может содержать неточности и не заменяет сертифицированный перевод в юридических, медицинских и иных критически важных ситуациях.'],
      ['Доступ и баланс', 'Часть функций предоставляется в пределах бесплатного лимита, остальные — после пополнения баланса или покупки пакета. Актуальная стоимость и объём отображаются до подтверждения операции в Telegram-боте.'],
      ['Допустимое использование', 'Запрещены попытки нарушить работу сервиса, получить чужие данные или доступ, обойти ограничения, распространять вредоносные материалы и использовать продукт в нарушение закона или прав третьих лиц.'],
      ['Ответственность пользователя', 'Пользователь самостоятельно проверяет перевод перед использованием и отвечает за законность отправленного контента. Не следует передавать через сервис данные, для обработки которых нет законных оснований.'],
      ['Изменение условий', 'Функции и условия могут обновляться по мере развития продукта. Существенные изменения публикуются на этой странице; продолжение использования после обновления означает согласие с новой редакцией.']
    ]
  }
};

const LegalPage = ({ type }) => {
  const page = content[type] || content.terms;
  const path = type === 'privacy' ? '/privacy' : '/terms';

  return (
    <div className="public-page">
      <SEOMetadata title={page.title} description={page.description} path={path} />
      <Header />
      <main className="nocturne-legal">
        <div className="nocturne-section-heading">
          <span>{page.label}</span><h1>{page.title}</h1><p>{page.description}</p>
        </div>
        <article>
          <p><strong>Редакция от 17 июля 2026 года.</strong></p>
          {page.sections.map(([heading, text]) => <section key={heading}><h2>{heading}</h2><p>{text}</p></section>)}
        </article>
      </main>
      <Footer />
    </div>
  );
};

export default LegalPage;
